import React from 'react';

export interface IRouterNavigationContextOwnProps {
  isRouterPromptActive?: boolean;
  setIsRouterPromptActive?: (isActive: boolean) => void;
}

export const RouterNavigationPromptContext = React.createContext<IRouterNavigationContextOwnProps>({});
